import AccountDetailsLink from './component.jsx'
export default AccountDetailsLink
